/**
 * sh-blog-carousel.js
 * ShopHub Blog — Storefront API カルーセル
 */

(function () {
  var DOMAIN = 'euphoriaec.myshopify.com';
  var TOKEN  = 'b8721a306a020419d90bfbe8b9378798';
  var API    = 'https://' + DOMAIN + '/api/2024-01/graphql.json';

  var PRODUCT_FIELDS = '\
    id \
    title \
    handle \
    priceRange { minVariantPrice { amount currencyCode } } \
    compareAtPriceRange { minVariantPrice { amount } } \
    images(first: 1) { edges { node { url altText } } } \
    variants(first: 1) { edges { node { id } } } \
    metafield_color: metafield(namespace: "shopify", key: "color-pattern") { value } \
    metafield_stickers: metafield(namespace: "custom", key: "stickers") { \
      references(first: 2) { \
        edges { \
          node { \
            ... on Metaobject { \
              fields { \
                key \
                value \
                reference { \
                  ... on MediaImage { image { url(transform: {maxWidth: 80}) } } \
                } \
              } \
            } \
          } \
        } \
      } \
    } \
  ';

  function formatPrice(amount) {
    return '¥' + Math.floor(parseFloat(amount)).toLocaleString('ja-JP');
  }

  function buildSwatches(metafield, colorMap, directColors) {
    var colors = [];
    if (directColors && directColors.length > 0) {
      colors = directColors.filter(Boolean);
    }
    if (colors.length === 0 && metafield && metafield.value) {
      try {
        var gids = JSON.parse(metafield.value);
        if (!Array.isArray(gids)) gids = [gids];
        colors = gids.map(function (g) { return colorMap[g] || null; }).filter(Boolean);
      } catch (e) {}
    }
    if (colors.length === 0) return '<div class="card-swatches"></div>';
    var MAX = 4;
    var html = '<div class="card-swatches">';
    colors.slice(0, MAX).forEach(function (c) {
      html += '<span class="card-swatches__dot" style="background-color:' + c + ';" title="' + c + '" aria-label="' + c + '"></span>';
    });
    if (colors.length > MAX) {
      html += '<span class="card-swatches__more">+' + (colors.length - MAX) + '色</span>';
    }
    html += '</div>';
    return html;
  }

  function fetchColorMap(products, callback) {
    var gidSet = {};
    products.forEach(function (p) {
      if (!p.metafield_color || !p.metafield_color.value) return;
      try {
        var gids = JSON.parse(p.metafield_color.value);
        (Array.isArray(gids) ? gids : [gids]).forEach(function (g) { gidSet[g] = true; });
      } catch (e) {}
    });
    var gids = Object.keys(gidSet);
    if (gids.length === 0) { callback({}); return; }
    var idsArg = gids.map(function (g) { return '"' + g + '"'; }).join(', ');
    var query = '{ nodes(ids: [' + idsArg + ']) { ... on Metaobject { id fields { key value } } } }';
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: query })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var map = {};
      var nodes = (data && data.data && data.data.nodes) || [];
      nodes.forEach(function (node) {
        if (!node || !node.id) return;
        var fields = node.fields || [];
        var colorField = fields.find(function (f) {
          return f.key === 'color' || f.key === '色' || f.key === 'iro';
        });
        if (colorField && colorField.value) { map[node.id] = colorField.value; }
      });
      callback(map);
    })
    .catch(function () { callback({}); });
  }

  function buildStickers(metafield) {
    if (!metafield || !metafield.references) return '';
    var edges = metafield.references.edges;
    if (!edges || !edges.length) return '';
    var html = '<div class="card-stickers">';
    edges.forEach(function (edge) {
      var fields = edge.node.fields || [];
      var iconField = fields.find(function (f) { return f.key === 'icon'; });
      var nameField = fields.find(function (f) { return f.key === 'name'; });
      var imgUrl = iconField && iconField.reference && iconField.reference.image
                    ? iconField.reference.image.url : null;
      if (imgUrl) {
        var alt = nameField ? nameField.value : '';
        html += '<img src="' + imgUrl + '" alt="' + alt + '" class="card-sticker__img" loading="lazy" width="60" height="60">';
      }
    });
    html += '</div>';
    return html;
  }

  // ─── カードHTML生成（横並びリスト型） ───────────────────────────────
  function buildCard(p, colorMap) {
    var img          = p.images.edges[0] ? p.images.edges[0].node : null;
    var price        = p.priceRange.minVariantPrice.amount;
    var compareAt    = p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice
                         ? p.compareAtPriceRange.minVariantPrice.amount : null;
    var hasDiscount  = compareAt && parseFloat(compareAt) > parseFloat(price);
    var url          = 'https://' + DOMAIN + '/products/' + p.handle;
    var variantId    = p.variants.edges[0] ? p.variants.edges[0].node.id : '';
    var productId    = (p.id || '').replace('gid://shopify/Product/', '');
    var variantIdNum = variantId.replace('gid://shopify/ProductVariant/', '');
    var numericId    = productId;
    var directColors = (window.ShCarouselColors && window.ShCarouselColors[numericId]) || null;

    var html = '';

    // リンク全体で横並び（画像左 + 情報右）
    html += '<a href="' + url + '" class="sh-blog-carousel-item-link" aria-label="' + p.title + '">';

    // 左：商品画像
    html += '<div class="sh-blog-carousel-item-img">';
    if (img) {
      html += '<img src="' + img.url + '" alt="' + (img.altText || p.title) + '" loading="lazy">';
    }
    html += '</div>';

    // 右：テキスト情報
    html += '<div class="sh-blog-carousel-item-info">';
    html += buildSwatches(p.metafield_color, colorMap || {}, directColors);
    html += buildStickers(p.metafield_stickers);
    html += '<p class="sh-blog-carousel-item-title">' + p.title + '</p>';
    html += '<div class="sh-blog-carousel-item-price">';
    if (hasDiscount) {
      html += '<span class="sh-blog-carousel-item-price--sale">' + formatPrice(price) + '</span>';
      html += '<span class="sh-blog-carousel-item-price--compare">' + formatPrice(compareAt) + '</span>';
    } else {
      html += '<span class="sh-blog-carousel-item-price--regular">' + formatPrice(price) + '</span>';
    }
    html += '<span class="sh-blog-carousel-item-tax">（税込）</span>';
    html += '</div>';
    html += '</div>'; // /.sh-blog-carousel-item-info

    html += '</a>'; // /.sh-blog-carousel-item-link

    // ウィッシュリストボタン（リンクの外、カードの右端）
    html += '<button type="button" class="wishlist-button sh-blog-carousel-item-wish"'
          + ' data-wishlist-toggle'
          + ' data-product-id="' + productId + '"'
          + ' data-handle="' + p.handle + '"'
          + ' data-variant-id="' + variantIdNum + '"'
          + ' data-label-add="お気に入りに追加"'
          + ' data-label-remove="お気に入りから削除"'
          + ' aria-pressed="false" aria-label="お気に入りに追加">';
    html += '<img class="wishlist-toggle__icon wishlist-toggle__icon--off"'
          + ' src="https://cdn.shopify.com/s/files/1/0609/3907/5680/files/ico_heart_off.svg?v=1774854417"'
          + ' alt="" aria-hidden="true" width="20" height="20">';
    html += '<img class="wishlist-toggle__icon wishlist-toggle__icon--on"'
          + ' src="https://cdn.shopify.com/s/files/1/0609/3907/5680/files/ico_heart_on.svg?v=1774854416"'
          + ' alt="" aria-hidden="true" width="20" height="20">';
    html += '</button>';

    return html;
  }

  // ─── カルーセル（リスト形式）組み立て ────────────────────────────────
  function buildCarousel(el, products, colorMap) {
    var label = el.dataset.label || '';

    var html = '';
    if (label) {
      html += '<span class="sh-blog-carousel-label">' + label + '</span>';
    }
    html += '<div class="sh-blog-carousel-list">';
    products.forEach(function (p) {
      html += '<div class="sh-blog-carousel-item">' + buildCard(p, colorMap) + '</div>';
    });
    html += '</div>';

    el.innerHTML = html;

    // ウィッシュリストボタンの opacity リセット
    el.querySelectorAll('.wishlist-button').forEach(function (btn) {
      btn.style.opacity = '';
    });
  }

  function gqlFetch(query, callback) {
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: query })
    })
    .then(function (r) { return r.json(); })
    .then(callback)
    .catch(function (err) { console.warn('sh-carousel error:', err); });
  }

  function fetchCollection(el, collectionId) {
    var query = '{ collection(id: "gid://shopify/Collection/' + collectionId + '") {'
      + ' products(first: 12) { edges { node { ' + PRODUCT_FIELDS + ' } } } } }';
    gqlFetch(query, function (data) {
      var col = data && data.data && data.data.collection;
      if (!col) return;
      var products = col.products.edges.map(function (e) { return e.node; });
      fetchColorMap(products, function (colorMap) { buildCarousel(el, products, colorMap); });
    });
  }

  function fetchProduct(el, productId) {
    var query = '{ product(id: "gid://shopify/Product/' + productId + '") { ' + PRODUCT_FIELDS + ' } }';
    gqlFetch(query, function (data) {
      var product = data && data.data && data.data.product;
      if (!product) return;
      fetchColorMap([product], function (colorMap) { buildCarousel(el, [product], colorMap); });
    });
  }

  function initCarousel(el) {
    if (el.dataset.collection) {
      fetchCollection(el, el.dataset.collection);
    } else if (el.dataset.product) {
      fetchProduct(el, el.dataset.product);
    }
  }

  function init() {
    document.querySelectorAll('.sh-blog-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();